import type { GetProps } from "antd";
import { Typography, theme } from "antd";
import type { FC } from "react";

export type IotTypographyErrorProps = GetProps<typeof Typography.Text>;

export const IotTypographyError: FC<IotTypographyErrorProps> = (props) => {
    const { token } = theme.useToken();

    return (
        <Typography.Text
            {...props}
            style={{ color: token.colorError }}
        />
    );
};
